<template>
	<v-dialog v-model="dialog" max-width="500px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="secondary" class="text-lowercase" icon v-on="on">
				<v-tooltip bottom>
					<template v-slot:activator="{ on }">
						<v-icon small v-on="on">mdi-lead-pencil</v-icon>
					</template>
					<span>edit user data</span>
				</v-tooltip>
			</v-btn>
		</template>
		<v-card v-if="!loading">
			<v-card-title>
				<span class="subtitle-2">New parameters of the team
					<span class="secondary--text">{{ email }}</span>
				</span>
			</v-card-title>
			<v-card-text>
				<v-container grid-list-md>
				<v-form v-model="valid" ref="form" validation>
					<v-row>
						<v-col cols="12" sm="8" md="6">
							<v-text-field
								color="#secondary"
								label="role"
								v-model="role"
								name="role"
								type="text"
								:rules="requiredRules"
								@change="onceMore()"
								>
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="8" md="6">
							<v-text-field
								color="secondary"
								label="company"
								v-model="company"
								name="company"
								type="text"
								:rules="requiredRules"
								@change="onceMore()"
								>
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="8" md="6">
							<v-text-field
								color="secondary"
								label="game id"
								v-model="gameId"
								name="gameId"
								type="text"
								:rules="requiredRules"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="8" md="6">
							<v-text-field
								color="secondary"
								label="current round"
								v-model.number="round"
								name="round"
								type="text"
								:rules="numberRules"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="8" md="6">
							<v-text-field
								color="secondary"
								label="description"
								v-model="description"
								name="description"
								type="text"
								:rules="requiredRules"
								@change="onceMore()"
								>
							</v-text-field>
						</v-col>
					</v-row>
				</v-form>
				</v-container>
				<v-row justify="center" class="error">{{ error }}</v-row>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="secobdary" text
					class="text-capitalize" 
					@click="closeDialog">
					Decline
				</v-btn>
				<v-btn color="secobdary" text
					class="text-capitalize"
					:disabled="!valid || Boolean(error)"
					@click="changeUserData"
					>Save</v-btn>
			</v-card-actions>
		</v-card>
		<div v-else class="text-xs-center">
			<v-progress-circular
				indeterminate
				:size="100"
				:width="4"
				color="secondary">
			</v-progress-circular>
		</div>
	</v-dialog>
</template>

<script>
	export default {
		props: ['team'],
		data () {
			return	{
				dialog: false,
				valid: false,
				error: '',
				requiredRules: [v => !!v || 'this field is required'],
				numberRules: [v => /^[+]?[0-9]/.test(v) || 'it\'s expected number'],
				email: this.team.email,
				company: this.team.company,
				gameId: this.team.gameId,
				round: this.team.currentRound,
				description: this.team.description,
				role: Object.keys(this.team.role)[0]
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			}
		},
		methods: {
			onceMore () {
				this.error = ''
				this.message = ''			
			},
			async changeUserData () {
				//console.log(this.team)
				if(this.$refs.form.validate()) {

					if (this.team.company == this.company &&
						Object.keys(this.team.role)[0] == this.role &&
						this.team.gameId == this.gameId &&
						this.team.currentRound == this.round &&
						this.team.description == this.description) {
						
						this.error = 'You didn\'t any change' 
					}
					else {
						const userData = {}
						userData.id = this.team.id
						userData.gameId = this.gameId
						userData.currentRound = this.round
						userData.company = this.company
						userData.role = {[this.role]: true}
						userData.description = this.description
						
						try {
							await this.$store.dispatch('changeUserData', userData)
							this.closeDialog ()				
						}
						catch (error) {
							this.error = error.message
						} 
					}
				}
				else {
					this.error = 'Enter all params please'
				}
			},
			closeDialog () {
				//reset
				this.dialog = false
				this.error = ''
			}
		}
	}
</script>
<style>
	.error{
		color: white
	}
</style>